import { __ } from './translation-service';

export const formatNumberOfNights = (numOfNights?: number) => {
    if (numOfNights && Number.isInteger(numOfNights) && numOfNights > 0) {
        return `${numOfNights} ${__(numOfNights === 1 ? 'night' : 'nights')}`;
    }
    return '';
}

export const formatItineraryInfo = (
    numOfNights?: number,
    numOfPorts?: number,
    numOfDaysAtSea?: number,
) => {
    let acc: string[] = [];

    if (numOfNights && Number.isInteger(numOfNights) && numOfNights > 0) {
        acc.push(`${numOfNights} ${__(numOfNights === 1 ? 'night' : 'nights')}`);
    }

    if (numOfPorts && Number.isInteger(numOfPorts) && numOfPorts > 0) {
        acc.push(`${numOfPorts} ${__(numOfPorts === 1 ? 'port' : 'ports')}`);
    }

    if (numOfDaysAtSea && Number.isInteger(numOfDaysAtSea) && numOfDaysAtSea > 0) {
        acc.push(`${numOfDaysAtSea} ${__(numOfDaysAtSea === 1 ? 'dayAtSea' : 'daysAtSea')}`);
    }

    return acc.join(', ');
};

export const formatMultipleLabels = (text: string, mappedObject: any): string => {
    return text.replace(/\[(([A-Za-z0-9#]+\s?))+]/g, (matched: string) => {
        return mappedObject[matched] || '';
    });
};
